import type { SVGProps } from 'react'
interface SvgBlockProps extends SVGProps<SVGSVGElement> {
  size?: string | number
}

const SvgBlock = ({ size = '1em', ...props }: SvgBlockProps) => (
  <svg height={size} viewBox="0 0 18 18" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="block_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#block_svg__a)">
      <path d="M9 16.653a7.4 7.4 0 0 1-2.983-.605 7.8 7.8 0 0 1-2.43-1.639 7.7 7.7 0 0 1-1.638-2.432 7.5 7.5 0 0 1-.601-2.986q0-1.587.601-2.981a7.7 7.7 0 0 1 1.637-2.426 7.75 7.75 0 0 1 2.43-1.635A7.45 7.45 0 0 1 9 1.348q1.588 0 2.983.601 1.395.602 2.43 1.635a7.7 7.7 0 0 1 1.638 2.426q.6 1.394.601 2.981a7.5 7.5 0 0 1-.601 2.986 7.7 7.7 0 0 1-1.637 2.432q-1.035 1.035-2.43 1.64A7.4 7.4 0 0 1 9 16.652m0-1.707a5.9 5.9 0 0 0 1.887-.306 5.6 5.6 0 0 0 1.671-.902l-8.305-8.3a5.8 5.8 0 0 0-1.2 3.553q0 2.49 1.731 4.223Q6.514 14.946 9 14.946m4.752-2.401a5.86 5.86 0 0 0 1.194-3.554q0-2.485-1.73-4.211T9 3.054q-.972 0-1.876.301t-1.673.884z" />
    </g>
  </svg>
)
export default SvgBlock
